var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5161 6.66699L8 18.1325V25.7953H14.129V48.9234H10.043V53.1285H8V57.3337H57.0323V53.1285H54.9892V48.9234H50.9032V25.7953H57.0323V18.1325L32.5161 6.66699ZM32.5161 11.2828L52.9462 20.8428V21.5902H42.7312V25.7953H46.8172V48.9234H18.2151V25.7953H22.3011V21.5902H12.086V20.8428L32.5161 11.2828Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0152 30.5816C30.0866 29.8205 29.1448 29.0335 29.1448 27.8079C29.1448 26.4016 30.4478 25.4211 32.6282 25.4211C34.9246 25.4211 35.7761 26.5177 35.8535 28.1304H38.7046C38.6143 25.9114 37.2597 23.873 34.5633 23.215V20.3896H30.693V23.1763C28.1901 23.7182 26.1775 25.3437 26.1775 27.8337C26.1775 30.8138 28.6417 32.2975 32.2411 33.1619C35.4664 33.9359 36.1115 35.0713 36.1115 36.2711C36.1115 37.1613 35.4793 38.5804 32.6282 38.5804C29.9705 38.5804 28.9255 37.3935 28.7836 35.8711H25.9453C26.1001 38.6965 28.2159 40.2834 30.693 40.8123V43.6119H34.5633V40.8381C37.0791 40.3608 39.0788 38.9029 39.0788 36.2582C39.0788 32.5942 35.9438 31.3428 33.0152 30.5816Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.26667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bankIcon.c4f8a373700625393ef82b27410a308b.svg";
export { ForwardRef as ReactComponent };